import script from "./process-edit-form.vue?vue&type=script&setup=true&lang=js"
export * from "./process-edit-form.vue?vue&type=script&setup=true&lang=js"

import "./process-edit-form.vue?vue&type=style&index=0&id=67682f64&lang=css"

const __exports__ = script;

export default __exports__